import MenuList from '../components/Menu/MenuList.js';
import { connect } from 'react-redux';
import { redux } from '../api';

const { setMenuCollapsed, newTaskState, setMenuOpenList } = redux.actions;

const { setCTUserInfo, setCurrentCTReportTime } = redux.actions;

const mapStateToProps = state => {
  return {
    userInfo: state.api.user.info,
    newTask: state.api.current.newTask,
    changeMenuTaskFlag: state.api.current.changeMenuTaskFlag,
    newTaskStateObj: state.api.current.newTaskStateObj,
    soundState: state.api.current.soundState,
    menuCollapsed: state.api.current.menuCollapsed,
    menuOpenList: state.api.current.menuOpenList,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMenuCollapsedData: data => dispatch(setMenuCollapsed(data)),
    newTaskState: data => dispatch(newTaskState(data)),
    setMenuOpenList: data => dispatch(setMenuOpenList(data)),
    setCTUserInfo: user => dispatch(setCTUserInfo(user)),
    setCurrentCTReportTime: data => dispatch(setCurrentCTReportTime(data)),
  };
};

const ConnectedMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuList);

export default ConnectedMenu;
